import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { GenericPageComponent } from './generic-page/generic-page.component';
import { MicrophoneCheckComponent } from './microphone-check/microphone-check.component';
import { StartScreenPhotoComponent } from './start-screen/start-screen-photo.component';

@NgModule({
  imports: [
    BrowserModule
  ],
  declarations: [
    LoadingOverlayComponent,
    InfoBoxComponent,
    GenericPageComponent,
    MicrophoneCheckComponent,
    StartScreenPhotoComponent
  ],
  exports: [
    LoadingOverlayComponent,
    InfoBoxComponent,
    GenericPageComponent,
    MicrophoneCheckComponent,
    StartScreenPhotoComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/shared.module.ts